import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';
import { EUnavailableReason } from '../../redux/reducers';

export const SET_PUBLICATION_BUTTON_CONFIG = 'SET :: PUBLICATION_BUTTON :: CONFIG';

interface IPayload {
  shouldSwitchToSelf: boolean;
  notEnoughMoney: boolean;
  unavailableReason: EUnavailableReason | null;
}

export type TSetPublicationButtonConfigAction = IReduxAction<typeof SET_PUBLICATION_BUTTON_CONFIG, IPayload>;

export const setPublicationButtonConfig = actionGenerator<typeof SET_PUBLICATION_BUTTON_CONFIG, IPayload>(
  SET_PUBLICATION_BUTTON_CONFIG,
);
